module.exports = __webpack_public_path__ + "img/mail.d50dc039.svg";